import { AxiosResponse } from 'axios';
import { useFormik } from 'formik';
import { useEffect, useRef, useState } from 'react';
import { useAuth } from 'src/contexts/auth';
import { ModelOfProduct } from '../../database';
import api from '../../services/api';
import * as Yup from 'yup';

const initialValuesOfProduct = {
	ORGAO: '',
	DESCRICAO: '',
	DESCRICAOCOMPLETA: '',
	MARCA: '',
	MODELO: '',
	FOTO: '',
	CODIGOBARRAS: '',
	NCM: '',
	AX_GRUPO: '',
	AX_GRUPOSUB: '',
	ULTIMOVALORCOMPRA: 0,
	ULTIMOVALORVENDA: 0,
	TIPOPRODUTO: 1,
};

export const useListProductsController = () => {
	const [productsData, setProductsData] = useState<ModelOfProduct[]>([]);
	const [allProductsData, setAllProductsData] = useState<ModelOfProduct[]>([]);
	const [selectedProduct, setSelectedProduct] = useState<ModelOfProduct>(initialValuesOfProduct);
	const [loading, setLoading] = useState(true);
	const [loadingEdit, setLoadingEdit] = useState(false);
	const [editDialog, setEditDialog] = useState(false);
	const [deleteDialog, setDeleteDialog] = useState(false);
	const [rows, setRows] = useState(0);
	const [maxData, setMaxData] = useState(false);
	const [loadingRows, setLoadingRows] = useState(false);

	const { userAgencyId } = useAuth();
	const toast: any = useRef();

	const validationSchema = Yup.object().shape({
		DESCRICAO: Yup.string().required('* Campo obrigatório'),
		DESCRICAOCOMPLETA: Yup.string().required('* Campo obrigatório'),
		MARCA: Yup.string().required('* Campo obrigatório'),
		// MODELO: Yup.string().required('* Campo obrigatório'),
		CODIGOBARRAS: Yup.string().required('* Campo obrigatório'),
		NCM: Yup.string().required('* Campo obrigatório'),
		AX_GRUPO: Yup.string().required('* Campo obrigatório'),
		AX_GRUPOSUB: Yup.string().required('* Campo obrigatório'),
		ULTIMOVALORCOMPRA: Yup.number()
			.typeError('O valor informado deve ser um número.')
			.required('* Campo obrigatório'),
		ULTIMOVALORVENDA: Yup.number()
			.typeError('O valor informado deve ser um número.')
			.required('* Campo obrigatório'),
	});

	const getAllProducts = () => {
		setLoading(true);
		api.get(`products/${userAgencyId}`)
			.then(response => {
				const data = response.data;

				setAllProductsData(data);
				setLoading(false);
			})
			.catch((response: AxiosResponse<any>) => {
				console.log('erro: ', response.status);
				setLoading(false);
			});
	};

	const getProducts = () => {
		console.log("--------> passou aqui <--------")
		if (rows === 0) {
			setLoading(true);
		} else {
			setLoadingRows(true);
		}
		api.post('products2', { ROW: rows, ORGAO: userAgencyId })
			.then(response => {

				console.log("Resposta da API: ", response)

				if (response.status === 204) {
					setMaxData(true);
					setLoading(false);
					setLoadingRows(false);
				} else {
					/*setProductsData(
						productsData.concat(
							response.data.datafilter((item: any) => {
								return item.ORGAO === userAgencyId;
							}),
						),
					);*/
					setProductsData(response.data);
					setLoading(false);
					setLoadingRows(false);
				}
			})
			.catch((response: AxiosResponse<any>) => {
				console.log('erro: ', response.status);
				setLoading(false);
				setLoadingRows(false);
			});
	};

	const removeProduct = (product: ModelOfProduct) => {
		setLoading(true);
		api.delete(`products/${product.ID}`)
			.then(response => {
				const newList = productsData.filter(product => product.ID !== response.data.ID);
				setProductsData(newList);
				setDeleteDialog(false);
				setLoading(false);
				toast.current.show({
					severity: 'success',
					summary: 'Remoção realizada',
					detail: 'O produto foi removida com sucesso!',
					life: 5000,
				});
			})
			.catch(() => {
				getProducts();
				setDeleteDialog(false);
				setLoading(false);
				toast.current.show({
					severity: 'error',
					summary: 'Remoção não realizado',
					detail: 'Falha ao realizar operação!',
					life: 5000,
				});
			});
	};

	const editProduct = (product: ModelOfProduct) => {
		setLoadingEdit(true);

		const editedProduct: ModelOfProduct = {
			...product,
			ORGAO: userAgencyId,
		};

		api.put(`products/${product.ID}`, editedProduct)
			.then(() => {
				getProducts();
				setEditDialog(false);
				window.location.reload();
				setLoadingEdit(false);
				toast.current.show({
					severity: 'success',
					summary: 'Edição realizada',
					detail: 'O produto foi editada com sucesso!',
					life: 5000,
				});
				setTimeout(() => {
					window.location.reload();
				}, 1500);
			})
			.catch(err => {
				console.log(err);
				getProducts();
				setEditDialog(false);
				setLoadingEdit(false);
				toast.current.show({
					severity: 'error',
					summary: 'Edição não realizado',
					detail: 'Falha ao realizar operação!',
					life: 5000,
				});
			});
	};



	const openDeleteDialog = (product: ModelOfProduct) => {
		setDeleteDialog(true);
		setSelectedProduct(product);
	};

	const closeDeleteDialog = () => {
		setDeleteDialog(false);
	};

	const openEditDialog = (product: ModelOfProduct) => {
		setEditDialog(true);
		setSelectedProduct(product);
	};

	const closeEditDialog = () => {
		setEditDialog(false);
	};

	const formik = useFormik<ModelOfProduct>({
		initialValues: {
			ORGAO: '',
			DESCRICAO: '',
			DESCRICAOCOMPLETA: '',
			MARCA: '',
			FOTO: '',
			CODIGOBARRAS: '',
			NCM: '',
			AX_GRUPO: '',
			AX_GRUPOSUB: '',
			ULTIMOVALORCOMPRA: 0,
			ULTIMOVALORVENDA: 0,
			TIPOPRODUTO: 1,
		},
		onSubmit: async values => await editProduct(values),
		validationSchema,
	});

	useEffect(() => {
		getProducts();
		//getAllProducts();
	}, []);

	return {
		getProductListController: {
			formik,
			allProductsData,
			productsData,
			selectedProduct,
			loading,
			deleteDialog,
			editDialog,
			loadingEdit,
			toast,
			rows,
			maxData,
			loadingRows,
			getProducts,
			getAllProducts,
		},
		handleProductListController: {
			removeProduct,
			editProduct,
			openDeleteDialog,
			closeDeleteDialog,
			openEditDialog,
			closeEditDialog,
			setRows,
		},
	};
};
